

export class Message {
  
  id: string = "";
  messageContent: string = "";
  sender: string = "";
  sentDate: Date = new Date();

  constructor(init?: Partial<Message>) {
    Object.assign(this, init);
  }

  setDate(date: string) {
    this.sentDate = new Date(date);
  }

  get align() {
     return (this.sender === 'system' ? 'left' : 'right') as "left" | "right";
  }
  
}



export class Chat {
  id: string = "";
  messages: Message[] = [];

  constructor(init?: Partial<Chat>) {
    Object.assign(this, init);
  }
}

